import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Eye, EyeOff, Shield } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import './Login.css';

const Login = () => {
  const { login } = useAppContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [lockoutMessage, setLockoutMessage] = useState(null);

  useEffect(() => {
    const savedEmail = localStorage.getItem('login-email');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      return;
    }

    setLoading(true);
    setLockoutMessage(null);

    const result = await login(email, password);

    if (result.success) {
      if (rememberMe) {
        localStorage.setItem('login-email', email);
      } else {
        localStorage.removeItem('login-email');
      }
      navigate('/');
    } else if (result.locked) {
      setLockoutMessage(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="login-simple">
      <div className="login-simple__container">
        {/* Logo and Brand */}
        <div className="login-simple__brand">
          <div className="login-simple__logo">
            <img src="/assets/logo-middle.png" alt="ChenaiXR Logo" className="sidebar__logo-image"
              onError={(e) => { e.target.style.display='none'; }}
            />
            <Shield size={40} strokeWidth={2} />
          </div>
          <h1 className="login-simple__brand-name">EndoNurseVR LMS</h1>
          <p className="login-simple__brand-subtitle">ChenaiXR Endoscopy Training Platform</p>
        </div>

        {/* Login Form */}
        <div className="login-simple__form-wrapper">

          <form onSubmit={handleSubmit} className="login-simple__form">
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="login-simple__password-input">
                <input
                  className="form-input"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="login-simple__password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            {lockoutMessage && (
              <div className="login-simple__error-message" style={{
                background: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#dc2626',
                padding: '12px',
                borderRadius: '6px',
                marginBottom: '16px',
                fontSize: '14px',
              }}>
                {lockoutMessage}
              </div>
            )}

            <div className="login-simple__options">
              <label className="login-simple__checkbox">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>Remember me</span>
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-primary login-simple__submit"
              disabled={loading || !email.trim() || !password.trim()}
            >
              {loading ? (
                <span className="login-simple__spinner" />
              ) : (
                <>
                  <LogIn size={18} />
                  Sign In
                </>
              )}
            </button>
          </form>


          {/* Footer */}
          <div className="login-simple__footer">
            <p className="login-simple__footer-text">
              By signing in, you agree to our{' '}
              <button type="button" className="login-simple__footer-link" onClick={() => alert('Terms of Service page coming soon!')}>
                Terms of Service
              </button>{' '}
              and{' '}
              <button type="button" className="login-simple__footer-link" onClick={() => alert('Privacy Policy page coming soon!')}>
                Privacy Policy
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;